module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "nav-main"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-link', {
    staticClass: "col-xs-3 btn-icon btn-icon--home",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("Accueil")]), _vm._v(" "), _c('router-link', {
    staticClass: "col-xs-3 btn-icon btn-icon--budget",
    attrs: {
      "to": "/services/budget",
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.navigateToBudget.apply(null, arguments)
      }
    }
  }, [_vm._v("Mon budget")]), _vm._v(" "), _c('router-link', {
    staticClass: "col-xs-3 btn-icon btn-icon--calendar",
    attrs: {
      "to": "/services/calendar",
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.navigateToCalendar.apply(null, arguments)
      }
    }
  }, [_vm._v("Mon agenda")]), _vm._v(" "), _c('router-link', {
    staticClass: "col-xs-3 btn-icon btn-icon--contacts",
    attrs: {
      "to": "/services/contacts",
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.navigateToContacts.apply(null, arguments)
      }
    }
  }, [_vm._v("Contacts")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-30e606dd!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 20
// module chunks = 0